export const toBigint = (
  inputValue: number | string,
  decimals?: number | string
) => {
  let input =
    typeof inputValue === 'string' ? Number.parseFloat(inputValue) : inputValue;
  let dec =
    typeof decimals === 'string' ? Number.parseInt(decimals) : decimals ?? 9;
  if (dec < 1) return BigInt(Math.floor(input));
  let decimalsToInt = input.toString().includes('.')
    ? input.toString().split('.', 2)[1].length
    : 0;
  decimalsToInt = Math.min(decimalsToInt, dec);
  let bn = BigInt(Math.floor(input * Math.pow(10, decimalsToInt)));
  if (dec > decimalsToInt) {
    let rest = dec - decimalsToInt;
    while (rest > 0) {
      bn *= BIG_10;
      rest--;
    }
  }
  return bn;
};

export const toNumber = (
  inputValue: bigint | string,
  decimals?: number | string
) => {
  let input = BigInt(inputValue);
  let dec =
    typeof decimals === 'string' ? Number.parseInt(decimals) : decimals ?? 9;
  let output: string = '';
  while (dec > 0) {
    dec--;
    const rest = input % BIG_10;
    if (rest == BIG_0) {
      input = input / BIG_10;
    } else {
      output = (input / BIG_10).toString() + '.' + rest.toString();
      break;
    }
  }
  if (output == '') {
    output = input.toString();
  }
  return Number((Number(output) / Math.pow(10, dec)).toFixed(Number(decimals)));
};

export const BIG_0 = BigInt(0);
export const BIG_1 = BigInt(1);
export const BIG_7 = BigInt(7);
export const BIG_10 = BigInt(10);
export const BIG_100 = BigInt(100);
export const BIG_1000 = BigInt(1000);
